<div mat-dialog-title>{{ "users.user.settings.2fa.secure.title" | translate }}</div>
<div mat-dialog-content>
	<p>{{ "users.user.settings.2fa.secure.instructions" | translate }}</p>
	<mat-form-field
		appearance="outline"
		class="w-full">
		<mat-label>{{ "users.user.settings.2fa.unique-code" | translate }}</mat-label>
		<input
			matInput
			required
			autocomplete="one-time-code"
			class="text-center"
			(keyup.enter)="secure()"
			mask="000 000"
			[(ngModel)]="mfaCode" />
	</mat-form-field>
</div>
<div
	mat-dialog-actions
	[align]="'end'">
	<button
		mat-button
		[mat-dialog-close]="false">
		{{ "core.cancel" | translate }}
	</button>
	@if (isLoading) {
		<mat-spinner diameter="40" />
	}
	@if (!isLoading) {
		<button
			mat-raised-button
			color="primary"
			class="split-button-left"
			(click)="secure()">
			{{ "core.secure" | translate }}
		</button>
	}
	@if (!isLoading) {
		<button
			mat-raised-button
			color="primary"
			class="split-button-right"
			[matMenuTriggerFor]="menu">
			<mat-icon>expand_more</mat-icon>
		</button>
	}
	<mat-menu #menu="matMenu">
		<button
			mat-menu-item
			(click)="secureByIp()">
			{{ "auth.connect.by-ip.label" | translate }}
		</button>
	</mat-menu>
</div>
